import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack, TranscriptIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { ThemeToggleButton } from "~/components/AssetModalV2/Content/Footer/components/ThemeToggleButton";
// These are temporary placeholders for the asset modal. They are used to test the asset modal layout.
// They will be replaced with the actual asset modal components when the asset modal is ready.
export const TemporaryAssetModalHeader = ()=>{
    const { setShowLeftPanel } = useAssetModalPanel();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                icon: Stack,
                label: "Toggle Left Panel",
                appearance: "ghost",
                color: "grey",
                onClick: ()=>setShowLeftPanel((prev)=>!prev)
            }),
            /*#__PURE__*/ _jsx("span", {
                children: "Header"
            })
        ]
    });
};
export const TemporaryAssetModalLeftPanel = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "text-grey-10",
        children: "Left Panel"
    });
};
export const TemporaryAssetModalContent = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "text-grey-10",
        children: "Content "
    });
};
export const TemporaryAssetModalContentFooter = ()=>{
    const { setShowContentLeftPanel } = useAssetModalPanel();
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(ThemeToggleButton, {}),
            /*#__PURE__*/ _jsx(IconButton, {
                icon: TranscriptIcon,
                label: "Toggle Content Left Panel",
                appearance: "ghost",
                color: "grey",
                onClick: ()=>setShowContentLeftPanel((prev)=>!prev)
            }),
            "Footer"
        ]
    });
};
